import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const ROUTE_LABELS: Record<string, string> = {
  '/blob-storage':     'Blob Storage',
  '/logic-apps':       'Logic Apps',
  '/functions':        'Azure Functions',
  '/app-service':      'App Service',
  '/bandwidth':        'Bandwidth',
  '/firewall':         'Azure Firewall',
  '/log-analytics':    'Log Analytics',
  '/virtual-machines': 'Virtual Machines',
  '/kql-builder':      'KQL Builder',
  '/guided':           'Guided Walkthrough',
  '/faq':              'FAQ',
  '/disclaimer':       'Disclaimer',
  '/privacy':          'Privacy Policy',
  '/history':          'Price History',
  '/guides/azure-blob-storage-pricing-uk':          'Blob Storage Pricing UK',
  '/guides/azure-log-analytics-pricing-uk':         'Log Analytics Pricing UK',
  '/guides/azure-egress-bandwidth-costs-explained':  'Egress Bandwidth Costs Explained',
  '/guides/log-analytics-search-job-vs-restore':    'Search Job vs Restore',
  '/guides/azure-firewall-pricing-uk':              'Azure Firewall Pricing UK',
  '/certifications/az-900-study-guide-uk': 'AZ-900 Study Guide',
  '/certifications/az-104-study-guide-uk': 'AZ-104 Study Guide',
  '/certifications/az-500-study-guide-uk': 'AZ-500 Study Guide',
  '/certifications/sc-200-study-guide-uk': 'SC-200 Study Guide',
  '/about': 'About',
};

const BASE_URL = 'https://www.azure-calc.co.uk';

export function Breadcrumbs() {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/') return null;

  const label = ROUTE_LABELS[path];
  if (!label) return null;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: BASE_URL },
      { '@type': 'ListItem', position: 2, name: label, item: `${BASE_URL}${path}` },
    ],
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="flex items-center gap-2 mb-4 text-[10px] font-bold tracking-widest uppercase" style={{ color: 'var(--text-tertiary)' }}>
        <Link to="/" className="hover:text-azure-blue transition-colors">HOME</Link>
        <ChevronRight size={10} style={{ color: 'var(--outline-variant)' }} />
        <span className="text-azure-blue-10">{label.toUpperCase()}</span>
      </nav>
    </>
  );
}
